import { Formik, useField } from 'formik';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { EmailScheduleData } from 'bloggers-backend/lib/emailScheduler/domain';
import ButtonWithLoading from '../../components/forms/SubmitButton';
import { Column } from '../../components/forms/Column';
import { useEditForm } from '../../components/forms/hooks/useEditForm';
import { DeleteFlow } from '../../components/DeleteFlow';
import { EditFormLoader } from '../../components/forms/EditFormLoader';
import { useUserTime } from '../../hooks/useUserTime';
import { ScheduledEmailsList } from './components/ScheduledEmailsList';
import { EnqueueEmailDialog } from './components/EnqueueEmailDialog';

function ActiveSwitch({ name }: { name: string }) {
  const [field, , helpers] = useField<boolean>(name);
  return (
    <FormControlLabel
      control={
        <Switch checked={!!field.value} onChange={(_, checked) => helpers.setValue(checked)} />
      }
      label="active"
    />
  );
}

export default function EditEmailSchedulerPage() {
  const { loading, loadedData, update, isSubmitLoading, validate, deleteEntity } =
    useEditForm<EmailScheduleData>('emailScheduler', '/email-schedulers');
  const formatUserTime = useUserTime();

  return (
    <EditFormLoader loading={loading} loadedData={loadedData}>
      <Formik initialValues={loadedData} onSubmit={update} validate={validate}>
        {({ values, submitForm }) => (
          <Box sx={{ display: 'flex', flexDirection: 'row', height: '100%', minHeight: 0 }}>
            <Column>
              <h2>Edit scheduler: {values.account?.email}</h2>

              <ActiveSwitch name="active" />

              <Typography variant="subtitle2">Engine state</Typography>
              <Typography variant="body2">
                locked until: {formatUserTime(values.engine?.lockedUntil as string)}
              </Typography>

              <ButtonWithLoading loading={isSubmitLoading} onClick={submitForm} />
              <DeleteFlow deleteWhat="EmailScheduler" deleteAction={deleteEntity} />
              {values.id && <EnqueueEmailDialog scheduleId={values.id} />}
            </Column>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minWidth: 0,
                m: 1,
                gap: 1,
              }}
            >
              {values.id && (
                <Box sx={{ flexGrow: 1, minHeight: 600 }}>
                  <ScheduledEmailsList scheduleId={values.id} />
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Formik>
    </EditFormLoader>
  );
}
